export const car = {
  vehicleClassCode: [
    {
      value: 1,
      label: '客车'
    }, {
      value: 2,
      label: '货车'
    },
    {
      value: 3,
      label: '挂车'
    }, {
      value: 5,
      label: '出租车'
    }, {
      value: 7,
      label: '特种车'
    }, {
      value: 8,
      label: '摩托车'
    }, {
      value: 9,
      label: '拖拉机、农用车'
    },
    {
      value: 10,
      label: '自卸'
    }, {
      value: 11,
      label: '低速'
    },
    {
      value: 21,
      label: '特一'
    }, {
      value: 22,
      label: '特二'
    }, {
      value: 23,
      label: '特三'
    }, {
      value: 24,
      label: '特四'
    }, {
      value: 50,
      label: '牵引车'
    }, {
      value: 51,
      label: '作业车'
    }, {
      value: 99,
      label: '其他'
    }
  ]
}

// 兼容旧 .NET agencyutils 的 { value, text } 与新版 { value, label } 结构。
export const normalizeVehicleClassOptions = (source) => {
  let list = source
  if (source && !Array.isArray(source)) {
    list = source.VehicleClassCodeData || source.vehicleClassCodeData || source.dictList || source.data || source.datas || []
    if (!Array.isArray(list) && source.VehicleClassCodeMap) {
      list = Object.keys(source.VehicleClassCodeMap).map(value => ({ value, text: source.VehicleClassCodeMap[value] }))
    }
  }
  if (!Array.isArray(list)) list = []
  return list.map(item => {
    if (item === null || item === undefined) return null
    if (typeof item !== 'object') return { value: Number(item), text: String(item), label: String(item) }
    const rawValue = item.value !== undefined ? item.value : (item.Value !== undefined ? item.Value : (item.keyCode !== undefined ? item.keyCode : item.code))
    const text = item.text !== undefined ? item.text : (item.label !== undefined ? item.label : (item.keyVal !== undefined ? item.keyVal : (item.Label !== undefined ? item.Label : item.name)))
    const value = rawValue === undefined || rawValue === null || rawValue === '' ? '' : (!isNaN(rawValue) ? Number(rawValue) : String(rawValue))
    const label = text == null ? String(value) : String(text)
    return Object.assign({}, item, { value, text: label, label })
  }).filter(item => item && item.value !== '')
}

export default {
  car,
  normalizeVehicleClassOptions
}



// WEBPACK FOOTER //
// ./src/data/car.js